<template lang="pug">
  Tab(:tabList="tabList"
    :path="path"
    ref="tabBox")
    //- .mainPage
    //-   el-button.backPage(plain type="primary" @click="backPage") 返回
    DataTablePage(
      v-if="!isChangeChart"
      mainColumn=""
      longColumn=""
      label="日冻结本期行码"
      labelName="num"
      :slot="tabName"
      :resource="resource"
      :requestData="requestData"
      :columns="columns"
      :tableInitList="tableInitList"
      :tableFullList="tableFullList"
      :filterInitList="filterInitList")
    .echartBox(slot="dataLine")
      .echartHeader
        FilterBox(
          class="filter-box"
          :columns="columns"
          :filterList="filterChartList"
          :filterBy="filterBy"
          @changeFilterBy="changeFilterBy")
        label.switchLabel(for="waveSwitch") 查看相关数据波动
        el-switch(
          id="waveSwitch"
          ref="waveSwitch"
          v-model="actSwitchVal"
          on-text="日冻结"
          on-color="#13ce66"
          on-value="dayWave"
          off-text="月冻结"
          off-color="#409eff"
          off-value="monthWave"
          :width="100"
          @change="changeSwitch")
      .dataChart(
        id="dataChart"
        ref="dataChart"
        :style="echartStyle")

</template>
<script>
import DataTablePage from '@/containers/DataTablePage'
import columns from './waterColumns.js'
import Tab from '@/components/Tab'
import Echarts from 'echarts'
import FilterBox from '@/components/FilterBox'
// import { operationUpdate } from '@/containers/DataTablePage/operation'
import { URL } from '@/utils/common'
import { fetchList } from '@/utils/api'
import { expire } from '@/utils/auth'
export default {
  name: 'wateruserHistory',
  components: {
    DataTablePage,
    Tab,
    Echarts,
    FilterBox
  },
  data () {
    const tabList = [{label: '实时抄表数据', name: 'realData'}, {
      label: '日冻结', name: 'dayData'
    }, {
      label: '月冻结', name: 'monthData'
    }, {
      label: '波动曲线图', name: 'dataLine'
    }]
    const counterId = this.$route.params
    return {
      actSwitchVal: 'dayWave',
      counterId: 0,
      path: this.$route.path,
      resource: '',
      requestData: counterId,
      tabList: tabList,
      tabName: this.$route.query.state || tabList[0].name,
      filterInitList: ['time', 'type', 'result'],
      filterChartList: ['copyTime'],
      tableInitList: ['time', 'image', 'num', 'result', 'type'],
      // tableDayList: ['copyTime', 'areaId', 'lnum', 'num', 'counterCode', 'type', 'excuteResult'],
      tableDayList: ['copyTime', 'period', 'hno', 'hname', 'phone', 'mobile', 'addr', 'cost', 'lnum', 'lquanty', 'num', 'quanty', 'counterCode', 'areaPathName', 'wave'],
      tableFullList: ['time', 'image', 'num', 'msg', 'type'],
      updateList: ['num'],
      filterBy: [],
      operation: [],
      columns: {
        ...columns,
        image: {
          label: '抄表行码',
          width: 220,
          type: 'custom',
          html: true,
          magnifying: {
            height: '180px',
            width: '200px'
          },
          style: {
            textAlign: 'center'
          },
          customRender (data, full, index) {
            return `<img src="${URL}/${data}" style="height:24px"></img>`
          }
        },
        wave: {
          label: '波动百分比',
          type: 'input',
          filter: {
            type: 'input',
            width: 100,
            suffix: {
              type: 'default',
              text: '%'
            },
            rules: [{ type: 'mixNumfloat', message: '只允许输入整数、浮点数' }]
          }
        },
        msg: {
          label: '点抄结果',
          width: 120,
          type: 'input',
          filter: {
            type: 'input',
            width: 100
          },
          form: {
            type: 'input',
            size: 12,
            rules: [{
              type: 'required',
              message: '请输入设备编号'
            }]
          },
          style: {
            textAlign: 'center'
          }
        },
        code: {
          label: '点抄状态码',
          width: 100,
          style: {
            textAlign: 'center'
          },
          filter: {
            type: 'input',
            width: 100
          }
        },
        type: {
          label: '数据类型',
          type: 'select',
          filter: {
            type: 'select'
          },
          // width: 100,
          style: {
            textAlign: 'center'
          },
          options: [{
            label: '全部',
            value: 'all'
          }, {
            label: '点抄',
            value: 'click_reading'
          }, {
            label: '定抄',
            value: 'timing_reading'
          }]
        },
        result: {
          label: '执行结果',
          type: 'select',
          width: 100,
          style: {
            textAlign: 'center'
          },
          filter: {
            type: 'select'
          },
          options: [{
            label: '全部',
            value: 'all'
          }, {
            label: '成功',
            value: 'success'
          }, {
            label: '失败',
            value: 'failed'
          }]
        }
      },
      dCharts: {},
      isChangeChart: false,
      echartOptions: {
        title: { text: '波动曲线图', subtext: '' },
        tooltip: {
          trigger: 'axis'
        },
        toolbox: {
          show: true,
          feature: {
            mark: {show: true},
            // dataView: {show: true, readOnly: false},
            magicType: {show: true, type: ['line', 'bar']},
            restore: {show: true},
            saveAsImage: {show: true}
          }
        },
        grid: {
          top: '10%',
          // left: '2%',
          // right: '4%',
          bottom: '2%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: []
        },
        yAxis: {
          type: 'value'
        },
        series: [],
        totalData: []
      },
      tabHeight: document.body.clientHeight - 250,
      tabWidth: document.body.clientWidth - 400
    }
  },
  computed: {
    echartStyle () {
      return {
        width: this.tabWidth + 'px',
        height: this.tabHeight + 'px'
      }
    }
    // actSwitchVal () {
    //   console.info('waveSwitch:', this.$refs.waveSwitch, this.$refs.waveSwitch.value)
    //   return this.$refs.waveSwitch.value
    // }
  },
  watch: {
    $route (to, form) {
      const { state } = to.query
      const { counterId } = to.params
      this.counterId = counterId
      this.tabName = state || this.tabList[0].name
      this.path = this.$route.path
      this.changeTabEvent(state)
    }
  },
  created () {
    this.getRouter()
  },
  mounted () {
    let result = expire()
    if (!result) {
      this.$router.push('/login')
    }
    this.initChart()
  },
  methods: {
    getRouter () {
      this.counterId = this.$route.params.counterId
      this.tabName = this.$route.query.state || this.tabList[0].name
      this.path = this.$route.path
      this.changeTabEvent(this.tabName)
      this.setDataTable(this.tabName)
    },
    initChart () {
      this.dCharts = Echarts.init(document.getElementById('dataChart'))
      this.dCharts.setOption(this.echartOptions)
    },
    changeTabEvent (value = this.tabList[0].name) {
      this.tabName = value
      const isChangeChart = value === 'dataLine'
      this.isChangeChart = isChangeChart
      if (!isChangeChart) {
        this.setDataTable(value)
      } else {
        this.getChartsData()
      }
    },
    setDataTable (value) {
      switch (value) {
        case 'realData': this.setReaderDataTable(); break
        case 'dayData': this.setDayDataTable(); break
        case 'monthData': this.setMonthDataTable(); break
      }
    },
    setReaderDataTable () {
      // this.tableInitList = ['time', 'image', 'code', 'type']
      this.tableInitList = ['time', 'image', 'num', 'result', 'type']
      this.resource = `/meterPayload/history/reading`
      this.filterInitList = ['time', 'type', 'result']
      this.tableFullList = ['time', 'image', 'num', 'result', 'type']
    },
    setDayDataTable () {
      this.tableInitList = this.tableDayList
      this.resource = `/meterPayload/history/day`
      this.filterInitList = ['copyTime', 'wave']
      this.tableFullList = this.tableDayList
    },
    setMonthDataTable () {
      this.tableInitList = this.tableDayList
      this.resource = `/meterPayload/history/month`
      this.filterInitList = ['copyTime', 'wave']
      this.tableFullList = this.tableDayList
    },
    getChartsData (type = this.actSwitchVal) {
      fetchList({
        resource: `/meterPayload/history/${type}?counterId=${this.counterId}`,
        filterBy: this.filterByToFilterText(this.filterBy),
        pageSize: 999,
        pageIndex: 1
      }).then(res => {
        if (res) {
          this.drawEchartsLine(res.data)
        }
      })
    },
    setEchartsOption (datas = []) {
      let xAxis = []
      let totalData = []
      // const newDatas = datas.reverse()
      const newDatas = datas
      if (newDatas.length) {
        xAxis = newDatas.map(data => { return this.$moment(new Date(data.copyTime)).format('YYYY-MM-DD HH:mm:ss') })
        totalData = newDatas.map(data => { return data.wave })
      } else {
        xAxis = newDatas.map(data => { return this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss') })
      }
      const legend = { data: [this.actSwitchVal] }
      // option['yAxis'] = option.totalData.length ? {min: Math.min.apply(null, option.totalData)} : {}
      return {
        xAxis,
        totalData,
        legend
      }
    },
    drawEchartsLine (datas = []) {
      const {xAxis, totalData, legend} = this.setEchartsOption(datas)
      let echartOptions = this.echartOptions
      const subText = totalData.length ? '' : '暂无波动'
      echartOptions['title'] = Object.assign(echartOptions['title'], {subtext: subText})
      echartOptions['xAxis'].data = xAxis
      // echartOptions['yAxis'] = elTotalData.length ? {min: Math.min.apply(elTotalData.data, totalData)} : {min: Math.min.apply(null, totalData)}
      const switchTitle = this.actSwitchVal === 'dayWave' ? '日冻结' : '月冻结'
      const series = {
        name: `${switchTitle}波动`,
        type: 'line',
        stack: switchTitle,
        data: totalData || [],
        markPoint: {
          data: [{type: 'max', name: '最大值'}, {type: 'min', name: '最小值'}]
        },
        markLine: {
          data: [{type: 'average', name: '平均值'}]
        }
      }
      echartOptions['series'] = [series]
      echartOptions['legend'] = legend
      this.dCharts.setOption(echartOptions)
    },
    changeFilterBy (data) {
      this.filterBy = [...data]
      this.getChartsData()
    },
    filterByToFilterText (filterBy) {
      return filterBy.map(({name, type, value}) => `${name}|${type}|${value}`).join(';')
    },
    backPage () {
      this.$router.push({ path: '/telnetReading/waterList' })
    },
    changeSwitch (value) {
      this.actSwitchVal = value
      this.getChartsData(value)
    }
  }
}
</script>
<style scoped lang="sass">
.mainPage
  .backPage
    margin-top: 20px
    margin-left: 20px
  .main
    padding-top: 0px
.echartBox
  margin: 0 auto
  .echartHeader
    margin: 0 10px 10px 5px
    height: 50px
    line-height: 50px
    .filter-box
      float: right
      margin-left: 12px
    .switchLabel
      margin: 0 10px 0 5px
      /* line-height: 30px */
      font-weight: 500
  .dataChart
    height: 100%
    width: 100%
    div
      height: 80%!important
      canvas
        height: 100%!important
        width: 100%
</style>


// WEBPACK FOOTER //
// WateruserHistory.vue?3c4a80a6